import React from "react";
import { App as AntdApp, Tabs } from "antd";
import ArticleContentEditor from "../../components/forms/Editor/ArticleContentEditor";
import { useOutletContext } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { UPDATE_CAMPAIGN } from "../../utils/api/campaign";
import Form from "../../components/forms/utils/Form";
import { CampaignContentSource, CampaignStatus, CampaignType } from "../../__generated__/graphql";
import { withAsyncErrorToast } from "../../utils/withToast";
import SelfHostedArticle from "./SelfHostedArticle";
import ProviderContent from "./ProviderContent";


const MetaArticle = () => {
  const { campaign } = useOutletContext<any>();
  const { notification } = AntdApp.useApp();
  const [updateCampaign, { loading }] = useMutation(UPDATE_CAMPAIGN);
  const readOnly = ![CampaignStatus.Draft, CampaignStatus.Paused].includes(campaign.status)
  const { __typename, ...content } = campaign.content || {};

  const logContext = {
    path: 'edit',
    campaignId: campaign._id,
    campaignType: campaign.type,
    contentSource: campaign.contentSource,
    status: campaign.status,
  };


  if (campaign.contentSource === CampaignContentSource.ProviderContent) {
    return <ProviderContent publications={campaign.publications} />
  }

  // Return the promise so the shared Form waits for the real result: on failure
  // withAsyncErrorToast re-throws, which stops Form from reset()-ing the editor
  // to blank and surfaces the error to the user.
  const handleUpdateArticle = async (content: any) => {
    await withAsyncErrorToast(
      'Save article',
      () =>
        updateCampaign({
          variables: { id: campaign._id, record: { content } },
        }),
      undefined,
      notification
    );
  };

  const hasSelfHostedPublication = campaign.publications.some(
    (publication: any) => publication.website.allowSelfHostedAdvertorials
  );

  const contentEditor = (
    <Form
      className="flex-1 relative bg-white rounded-md px-4 py-4 mb-10 space-y-6 sm:space-y-5"
      defaultValues={content}
      submitButtonText="Update Meta-article"
      onSubmit={handleUpdateArticle}
      readOnly={readOnly}
      loading={loading}
      logContext={logContext}
    >
      <ArticleContentEditor
        readOnly={readOnly}
        allowSponsoredLinks={campaign.type === CampaignType.Filler}
      />
    </Form>
  );

  if (!hasSelfHostedPublication) {
    return contentEditor;
  }

  const tabs = campaign.publications.map((publication: any) => {
    if (publication.website.allowSelfHostedAdvertorials) {
      const selfHostedEditor = <SelfHostedArticle publication={publication} />;
      return {
        key: publication._id,
        label: publication.website.name,
        children: selfHostedEditor,
      };
    }
    return {
      key: publication._id,
      label: publication.website.name,
      children: contentEditor,
    };
  });
  return (
    <div>
      <Tabs type="card" items={tabs} />
    </div>
  );
};

export default MetaArticle;
